import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

export class SubCompany {
  @Prop({ type: String, index: true, default: () => generateEntityId('subc') })
  _id: string

  @Prop({ type: String })
  name: string
}
